import React from 'react'

import DataGrid from '../UI/DataGrid'
import {
  DollarValue,
  AddedPercentage,
  PercentageOf,
  RawValue
} from '../UI/FormulaTokens'
import ReferenceValueCard from './ReferenceValueCard'

const ListReferenceValues = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'formattedType', title: 'Type' },
    { name: 'valueComponent', title: 'Value' }
  ]

  const gridRowMappingFn = refVal => {
    const id = refVal.id
    const { name, valueType, formattedType, formattedValue } = refVal.attributes
    let valueComponent

    switch (valueType) {
      case 'dollar_value':
        valueComponent = <DollarValue value={formattedValue} />
        break
      case 'added_percentage':
        valueComponent = <AddedPercentage value={formattedValue} />
        break
      case 'percentage_of':
        valueComponent = <PercentageOf value={formattedValue} />
        break
      default:
        valueComponent = <RawValue value={formattedValue} />
    }

    return {
      id: id,
      name: name,
      formattedType: formattedType,
      valueComponent: valueComponent
    }
  }

  const gridSorting = [{ columnName: 'name', direction: 'asc' }]
  const sortingStateColumnExtensions = [
    { columnName: 'valueComponent', sortingEnabled: false }
  ]

  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  const filteringStateColumnExtensions = [
    { columnName: 'valueComponent', filteringEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'formattedType', width: 250 },
    { columnName: 'valueComponent', align: 'right', width: 250 }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="reference-values"
      resourceSingularName="Reference value"
      resourcePluralName="Reference values"
      nameAttribute="name"
      clientRootPath="/reference-values"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      filteringStateColumnExtensions={filteringStateColumnExtensions}
      sortingStateColumnExtensions={sortingStateColumnExtensions}
      tableColumnExtensions={tableColumnExtensions}
      detailsCard={ReferenceValueCard}
    />
  )
}

export default ListReferenceValues



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ListReferenceValues.jsx